const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import ModelData from "../../../public/model_data";
import BagView from "./bag_view";
import ModuleManager from "../../../../framework/core/module_manager";
import { BgVipModule } from "../vip/bg_vip_module";
import EventManager from "../../../../manager/event_manager";
import { NotifyData } from "../../../public/notify_data";
import { RedPointModule } from "../../../public/component/redpoint_component";

const const_tag_btn_name_map = {
    ['tag_vip']: 'VipBtn',
    ['tag_daoju']: 'DaoJuBtn',
}

@ccclass
@moduleInit("Bag")
export default class Bag extends ModuleBase<BagView, null>  {
    curShowType = null
    vipModule = null
    rankDataByType = []
    constructor() {
        super()
        this.layer = ViewLayer.High;
        this.windowPrefabResPath = "package/hall/module/bag/hall_bag";
        this.viewType = BagView;
        this.modelType = null
        this.autoShowAnim = true
        this.needAnim = true
        this.needViewMask = true
        this.needDeferShow = true
    }

    onInit(intentData: any) {
        super.onInit(intentData);
    }

    onDeferShow(intentData) {
        this.bindEvent()
        this.onButtonClickName(this.getBtnNameByTag(intentData.tag || 'tag_daoju'))
        if (intentData.tag == 'tag_vip'){
            this.view.changeBtnShow(false)
            this.openVipPanel()
            this.show()
        }
        else
        {
            this.getBagData()
        }
    }


    protected onButtonClickName(name : string) {
        let self = this
        switch (name) {
            case "CloseBtn":
                this.hide()
                break;
            case "DaoJuBtn":
                this.view.changeBtnShow(true)
                break;
            case "VipBtn":
                this.view.changeBtnShow(false)
                this.openVipPanel()
                break;
            default:
                break;
        }
    }


    //打开VIP界面
    openVipPanel(){
        if (this.vipModule == null){
            this.vipModule = ModuleManager.instance.showModule<BgVipModule>(BgVipModule)
            this.vipModule.node.parent = this.view.vipNode
        }else{
            this.vipModule.updateModule();
        }
    }

    //获取背包数据
    getBagData(){
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "item/getUserItemList?",
            params: {
                gameUserId: ModelData.instance.roleData.id,
            },
            showNetPrompt:true
        }
        this.apiHttpGet(requestData, (respone) => {
           let isBagRedPoint = respone.data.length > 0
            if (respone.data.length == 1){
                if (respone.data[0].itemCode == "Item_Horn" || respone.data[0].itemCode == "LABA_ITEM"){
                    isBagRedPoint = false
                }
            }
            EventManager.instance.dispatch('Event_Notify_RedPoint_Change_Refresh', RedPointModule.Bag_Vip, isBagRedPoint || NotifyData.isVipRedPoint)
            self.view.updateShowItem(respone.data)
            self.getBuffData()
        })
    }

    //获取BUFF数据
    getBuffData(){
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "buff/getUserBuffList?",
            params: {
                gameUserId: ModelData.instance.roleData.id,
            },
            showNetPrompt:true
        }
        this.apiHttpGet(requestData, (respone) => {
            self.view.updateShowBuffStatus(respone.data)
            if (!self.node.active){
                self.show()
            }
        })
    }

    //使用道具
    useItemEvent(itemId, useCount){
        if (itemId == null){ return }
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "item/useItem?",
            params: {
                gameUserId: ModelData.instance.roleData.id,
                itemId:itemId,
                itemNum:useCount
            },
            showNetPrompt:true
        }
        this.apiHttpGet(requestData, (respone) => {
            self.getBagData()
        })
    }

    private bindEvent() {
        this.eventBind("click_use_item", this.useItemEvent)
        this.eventBind('buy_item_event', this.getBagData)
    }

    protected getBtnNameByTag(tag){
        return const_tag_btn_name_map[tag]
    }
}